import React, { useState } from 'react'

import Link from 'next/link'

import { PhoneCall } from '@phosphor-icons/react'
import Logo from 'Components/Blocks/Logo'
import { BookMeetingModal, JoinUsNowModal } from 'Components/Blocks/Modals'
import { Button, Row, Text } from 'Components/UI'

import { CONTACT_PHONE } from 'Constants/ContactData'
import { HEADER_HEIGHT_PX } from 'Constants/Navigation'
import { HOME } from 'Constants/Paths'

import { useResponsiveLayout } from 'Hooks'

import DesktopNavigation from './DesktopNavigation'
import MobileNavigation from './MobileNavigation'
import { Container, Content, PhoneLink } from './styles'

type Props = {
  secondary?: boolean
}

function Header({ secondary }: Props) {
  const { isMobile, isTablet, isDesktop, isWideDesktop } = useResponsiveLayout()

  const [joinUsModalOpened, setJoinUsModalOpened] = useState(false)
  const [bookMeetingOpened, setBookMeetingOpened] = useState(false)

  return (
    <Container
      height={isDesktop ? HEADER_HEIGHT_PX.DESKTOP : HEADER_HEIGHT_PX.MOBILE}
      position={isDesktop ? 'fixed' : 'relative'}
      px={isDesktop ? 6 : 4}
      py={isDesktop ? 6 : 7}
    >
      <Content>
        {!isDesktop && (
          <Button
            width={1}
            onClick={() =>
              secondary
                ? setBookMeetingOpened(true)
                : setJoinUsModalOpened(true)
            }
          >
            {secondary ? 'Book a Meeting' : 'Join Us Today'}
          </Button>
        )}

        <Row
          alignCenter
          fullWidth
          justifyCenter={secondary && (isMobile || isTablet)}
          spaceBetween={!(secondary && (isMobile || isTablet))}
        >
          <Link href={HOME}>
            <Logo isClickable secondary width={isDesktop ? 150 : 116} />
          </Link>

          {isDesktop ? (
            <>
              {!secondary && <DesktopNavigation />}

              <Row alignCenter gap={7}>
                {isWideDesktop && (
                  <PhoneLink href={`tel:${CONTACT_PHONE}`}>
                    <PhoneCall size={20} weight="bold" />

                    <Text medium nowrap screen20>
                      {CONTACT_PHONE}
                    </Text>
                  </PhoneLink>
                )}

                <Button
                  large
                  onClick={() =>
                    secondary
                      ? setBookMeetingOpened(true)
                      : setJoinUsModalOpened(true)
                  }
                >
                  {secondary ? 'Book a Meeting' : 'Join Us Today'}
                </Button>
              </Row>
            </>
          ) : secondary ? null : (
            <MobileNavigation />
          )}
        </Row>
      </Content>

      <BookMeetingModal
        isOpened={bookMeetingOpened}
        onClose={() => setBookMeetingOpened(false)}
      />

      <JoinUsNowModal
        isOpened={joinUsModalOpened}
        onClose={() => setJoinUsModalOpened(false)}
      />
    </Container>
  )
}

export default Header
